/**
 * List of static articles
 */
export default [
  {
    id: 'ABOUT_US',
    fr: 'a-propos-de-nous',
    en: 'about-us',
  },
  {
    id: 'LEGAL_TERM',
    fr: 'mentions-legales',
    en: 'legal-terms',
  },
  {
    id: 'TERMS_OF_USE',
    fr: 'conditions-generales-d-utilisation',
    en: 'terms-of-use',
  },
  {
    id: 'SITEMAP',
    fr: 'plan-du-site',
    en: 'sitemap',
  },
  {
    id: 'ACCESSIBILITY_CHART',
    fr: 'charte-accessibilite',
    en: 'accessibility-chart',
  },
  {
    id: 'PROVIDER',
    fr: 'fournisseur',
    en: 'provider',
  },
  {
    id: 'BANKING_ACCESSIBILITY',
    fr: 'accessibilite-bancaire',
    en: 'banking-accessibility',
  },
  {
    id: 'REGIONAL_DEVELOPMENT',
    fr: 'contribution-amenagement-territoire',
    en: 'regional-planning-and-development',
  },
  {
    id: 'UNIVERSAL_POSTAL_SERVICE',
    fr: 'service-universel-postal',
    en: 'universal-postal-service',
  },
  {
    id: 'PRESS_TRANSPORT_AND_DELIVERY',
    fr: 'transport-et-distribution-presse',
    en: 'press-transport-and-delivery',
  },
  {
    id: 'POSTAL_BANK',
    fr: 'la-banque-postale-la-banque-de-tous',
    en: 'la-banque-postale-the-bank-for-all',
  },
  {
    id: 'GEOPOST',
    fr: 'geopost-le-colis-meme-a-lautre-bout-du-monde',
    en: 'geopost--parcels-even-at-the-other-end-of-the-world',
  },
  {
    id: 'LA_POSTE_NETWORK',
    fr: 'le-reseau-la-poste-au-service-du-territoire',
    en: 'the-la-poste-network-serving-the-country',
  },
  {
    id: 'SERVICES_MAIL_PARCELS',
    fr: 'services-courrier-colis',
    en: 'services-mail-parcels',
  },
  {
    id: 'DIGITAL_SERVICES',
    fr: 'numerique',
    en: 'digital-services',
  },
  {
    id: 'STRATEGY_2020',
    fr: 'notre-strategie-pour-2020',
    en: 'our-2020-strategy',
  },
  {
    id: 'URBAN_LOGISTICS',
    fr: 'logistique-urbaine',
    en: 'urban-logistics',
  },
  {
    id: 'ENERGY_TRANSITION',
    fr: 'transition-energetique',
    en: 'energy-transition',
  },
  {
    id: 'SERVICES_INDIVIDUALS',
    fr: 'connaissance-client',
    en: 'services-to-individuals',
  },
  {
    id: 'MODERNISING_PUBLIC_ACTION',
    fr: 'modernisation-action-publique',
    en: 'modernising-public-action',
  },
  {
    id: 'ECOMMERCE',
    fr: 'e-commerce',
    en: 'ecommerce',
  },
  {
    id: 'SOCIAL_COMMITMENT',
    fr: 'notre-engagement-societal',
    en: 'our-social-commitment',
  },
  {
    id: 'ENVIRONMENTAL_CHANGES',
    fr: 'transitions-ecologiques',
    en: 'environmental-changes',
  },
  {
    id: 'SOCIAL_AND_TERRITORIAL_COHESION',
    fr: 'cohesion-sociale-et-territoriale',
    en: 'social-and-territorial-cohesion',
  },
  {
    id: 'ETHICAL_AND_RESPONSIBLE_DIGITAL_SERVICES',
    fr: 'numerique-responsable-et-ethique',
    en: 'ethical-and-responsible-digital-services',
  },
  {
    id: 'PARTNERS',
    fr: 'partenariats',
    en: 'partners',
  },
];
